import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { NAV_ITEMS, SERVICES, ASSETS, TONES } from "@/data/content";
import { openConsentSettings } from "@/lib/analytics";

export const Footer = () => {
  return (
    <footer data-testid="main-footer" className="relative overflow-hidden bg-[#0E1B31] text-[#F8F6F0]">
      <div className="absolute inset-0 mesh-navy opacity-80" />
      <div className="perspective-grid light" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-20 pb-10 lg:pt-28">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8">
          <div className="lg:col-span-5">
            <Link to="/" data-testid="footer-logo" className="inline-block">
              <img src={ASSETS.logo} alt="CRESTIA — Growth & Transformation" className="h-12 w-auto brightness-0 invert" />
            </Link>
            <p className="mt-8 font-display text-3xl lg:text-4xl leading-[1.15]">
              Στρατηγική. Οργάνωση. Ανάπτυξη.{" "}
              <span className="italic text-[#E39C82]">Μετρήσιμα αποτελέσματα.</span>
            </p>
            <p className="mt-5 text-sm leading-relaxed text-white/65 max-w-md">
              Boutique εταιρεία επιχειρηματικής συμβουλευτικής, ανάπτυξης και μετασχηματισμού. Από τη στρατηγική μέχρι την εφαρμογή.
            </p>
            <div className="mt-4 flex flex-wrap items-baseline gap-x-2 gap-y-1" data-testid="footer-contact">
              <p className="w-full sm:w-auto font-mono-brand text-[11px] tracking-[0.3em] uppercase text-[#C5A059]">ΕΠΙΚΟΙΝΩΝΙΑ</p>
              <span className="inline-flex items-baseline gap-2 whitespace-nowrap text-sm text-white/70">
                <span aria-hidden="true" className="hidden sm:inline">·</span>
                <a href="mailto:info@crestia.gr" className="hover:text-white transition-colors duration-300">info@crestia.gr</a>
              </span>
              <span className="inline-flex items-baseline gap-2 whitespace-nowrap text-sm text-white/70">
                <span aria-hidden="true">·</span>
                <a href="tel:+306978452234" className="hover:text-white transition-colors duration-300">+30 697 845 2234</a>
              </span>
            </div>
          </div>

          <div className="lg:col-span-3 lg:pl-8">
            <p className="font-mono-brand text-[11px] tracking-[0.3em] uppercase text-[#C5A059]">Πλοήγηση</p>
            <ul className="mt-6 space-y-3.5">
              {NAV_ITEMS.map((item) => (
                <li key={item.id}>
                  <Link to={item.path} data-testid={`footer-link-${item.id}`} className="group inline-flex items-center gap-2 text-sm text-white/70 hover:text-white transition-colors duration-300">
                    {item.label}
                    <ArrowUpRight className="h-3 w-3 opacity-0 -translate-x-1 transition-all group-hover:opacity-100 group-hover:translate-x-0" />
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <p className="font-mono-brand text-[11px] tracking-[0.3em] uppercase text-[#C5A059]">Υπηρεσίες</p>
            <ul className="mt-6 space-y-3.5">
              {SERVICES.map((s) => (
                <li key={s.id}>
                  <Link to={`/services#${s.id}`} data-testid={`footer-service-${s.id}`} className="group inline-flex items-start gap-3 text-sm text-white/70 hover:text-white transition-colors duration-300">
                    <span className="mt-1.5 h-1.5 w-1.5 rounded-full shrink-0" style={{ background: TONES[s.tone].accent }} />
                    {s.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-xs text-white/50">© 2026 CRESTIA — Επιχειρηματική Συμβουλευτική &amp; Μετασχηματισμός</p>
          <p className="font-mono-brand text-[11px] tracking-widest text-white/40">ΑΝΑΛΥΣΗ → ΣΤΡΑΤΗΓΙΚΗ → ΣΧΕΔΙΑΣΜΟΣ → ΕΦΑΡΜΟΓΗ → ΜΕΤΡΗΣΗ → ΒΕΛΤΙΩΣΗ</p>
        </div>
        <nav aria-label="Νομικές πληροφορίες" className="mt-4 flex flex-col items-start gap-y-2 sm:flex-row sm:items-center sm:gap-x-5">
          <Link to="/privacy-policy" data-testid="footer-privacy-link" className="text-xs text-white/50 transition-colors hover:text-white">Πολιτική Απορρήτου</Link>
          <Link to="/terms" data-testid="footer-terms-link" className="text-xs text-white/50 transition-colors hover:text-white">Όροι Χρήσης</Link>
          <Link to="/cookies" data-testid="footer-cookies-link" className="text-xs text-white/50 transition-colors hover:text-white">Πολιτική Cookies</Link>
          <button type="button" onClick={openConsentSettings} data-testid="footer-cookie-settings" className="min-h-[44px] text-left text-xs text-white/70 transition-colors hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-white">Ρυθμίσεις cookies</button>
        </nav>
      </div>
    </footer>
  );
};
